module.exports = __webpack_public_path__ + "static/img/auto-phone.988bb2cf.png";